import axios from "axios";
import { apiUrls } from "../api.config";

import { BehaviorSubject } from 'rxjs';

const subject = new BehaviorSubject("33");
export const LoginService = {
    getUserDetailsById,
    getToken,
    checkCredentials,
    getRefreshToken,
    getSubject,
    setSubject
}

function getUserDetailsById(userId) {
    let url = apiUrls.getUserDetailsByUserId.URL.replace("{userId}", userId);
    return axios.get(url)
        .then(response => response.data);
}

function getSubject(){
    //subject.subscribe(console.log);
return subject;

// two subscribers will get new value => output: 456, 456
//subject.next(456);
}

function setSubject(value){
  
// two subscribers will get new value => output: 456, 456
subject.next(value);
}
function getToken(authCode) {
   /* let test = { "shortId": "guptam",

    "userName": null,

    "email": null,

    "access_token": "sample_token_1234567",

    "refresh_token": "YEEykAHDE9+g9J8BN3LLIPgqWSJEUhRpbpY5kLjxHrJTvjWhoajzml8D3OBPzake",

    "id_token": "wJcDw1FBgzRBcyuwtHqPJnSaMuVYMnLxK0lRsTxdwMG3ucRxFwb3hCH4gAr00M2nppA/wOAxG4Qd2fGLvWeUljag/jo7rnu+n1ogBrMoYa+mf6ciqSr+/1KmE4gqcmYjzAZvu97+zFyEqpzQd+9zD/HJEShWk6OqjhILx/ZOpv0EKOHj8p1FEJPrw/lZuIzFCdiDuaRuaJhLL9NIyMHI7oyaHsrCnZKQCOmLuj1+wUmk3KwZ/+P9eF/AOqUINy91z9jkRVDWkaSeo6DrEN8ynorpxU4M+b812udhLTnpeoMYVMKiR0pwZajs7GRQXGldyfn8KErifYEpP1LaU0uRwzyflonwfHKAYkJ39sGX9EFD6mPVfWYiZ0ekay52Twah4APE8nnSkgIC1suYPqoJMeJ3PVvZlLvGfB1jX4T3qf9AVbwClni0ZPTGERvmT/Sa9ZlS401smQ/5bw88M9221n+aONqQbBReuTu7xFiC7oqnRnbz+HsdNLQgoR+9lDRZIh8OqtLZ0/OQvMbDpBD0ThF7POWAyHYL5/iR3RJ7nPFwQq0WfYxIS79r9k/FF29X7k2FYZoNDK7aNukuddC3f1SJq82H1e7rXkF1H8pet9LroyGmghmmNu5aLXk+jRInZQkjjh4fAcurJ0xnBPnyMeforO5yq2HBc1R4QT7eAbOKDQd8azPObDdTFsFdQZQp2A069RAlVf8hCKMajfzPMGPshfNvwag27efQKkMitunHlwJRTEWGnKrm/MmCdNQImAP7ehnSAdd81peN/yWSLrNO86Cey6EA90BVOYqTODus02BrKnQ2Y2jH3zCt1SSvQynWCqk0dxDq1VtgB3V9Eo/AjD5HbT+fvKUcQ4zk35ULs7vfllEqPd2eJOJQb0KxqyQjwDCCz6Z2txGfJBNtaDONTOIvLiOttxDzdRQTFR0tCn/2jg43qDwVhLI/VT/IcEefV5ST5ywk+2MZCz+B6Cybw9e4d/TbYH8SnpTPboQTug5NOYOWqoa6UpyCYIwGEfJnfq8syH1yzuwqo9XyC3+ts78ztaxK4v5ee+zs8x4=",

    "token_type": "Bearer",

    "expires_in": "1799"

    }
    return test;*/
    return axios.get(apiUrls.tokenUrl.URL+'?authCode='+authCode)
       .then(response => response.data);
}

function getRefreshToken(refreshToken) {
    /* let test = { "shortId": "guptam",
 
     "userName": null,
 
     "email": null,
 
     "access_token": "sample_token_1234567",
 
     "refresh_token": "YEEykAHDE9+g9J8BN3LLIPgqWSJEUhRpbpY5kLjxHrJTvjWhoajzml8D3OBPzake",
 
     "id_token": "wJcDw1FBgzRBcyuwtHqPJnSaMuVYMnLxK0lRsTxdwMG3ucRxFwb3hCH4gAr00M2nppA/wOAxG4Qd2fGLvWeUljag/jo7rnu+n1ogBrMoYa+mf6ciqSr+/1KmE4gqcmYjzAZvu97+zFyEqpzQd+9zD/HJEShWk6OqjhILx/ZOpv0EKOHj8p1FEJPrw/lZuIzFCdiDuaRuaJhLL9NIyMHI7oyaHsrCnZKQCOmLuj1+wUmk3KwZ/+P9eF/AOqUINy91z9jkRVDWkaSeo6DrEN8ynorpxU4M+b812udhLTnpeoMYVMKiR0pwZajs7GRQXGldyfn8KErifYEpP1LaU0uRwzyflonwfHKAYkJ39sGX9EFD6mPVfWYiZ0ekay52Twah4APE8nnSkgIC1suYPqoJMeJ3PVvZlLvGfB1jX4T3qf9AVbwClni0ZPTGERvmT/Sa9ZlS401smQ/5bw88M9221n+aONqQbBReuTu7xFiC7oqnRnbz+HsdNLQgoR+9lDRZIh8OqtLZ0/OQvMbDpBD0ThF7POWAyHYL5/iR3RJ7nPFwQq0WfYxIS79r9k/FF29X7k2FYZoNDK7aNukuddC3f1SJq82H1e7rXkF1H8pet9LroyGmghmmNu5aLXk+jRInZQkjjh4fAcurJ0xnBPnyMeforO5yq2HBc1R4QT7eAbOKDQd8azPObDdTFsFdQZQp2A069RAlVf8hCKMajfzPMGPshfNvwag27efQKkMitunHlwJRTEWGnKrm/MmCdNQImAP7ehnSAdd81peN/yWSLrNO86Cey6EA90BVOYqTODus02BrKnQ2Y2jH3zCt1SSvQynWCqk0dxDq1VtgB3V9Eo/AjD5HbT+fvKUcQ4zk35ULs7vfllEqPd2eJOJQb0KxqyQjwDCCz6Z2txGfJBNtaDONTOIvLiOttxDzdRQTFR0tCn/2jg43qDwVhLI/VT/IcEefV5ST5ywk+2MZCz+B6Cybw9e4d/TbYH8SnpTPboQTug5NOYOWqoa6UpyCYIwGEfJnfq8syH1yzuwqo9XyC3+ts78ztaxK4v5ee+zs8x4=",
 
     "token_type": "Bearer",
 
     "expires_in": "1799"
 
     }
     return test;*/
     return axios.get(apiUrls.refreshTokenUrl.URL)
        .then(response => response.data);

     // return axios.get("http://localhost:3001/api/publicInfo")
       // .then(response => response.data);
 }
function checkCredentials(requestPayload) {
    return axios.post(apiUrls.loginUrl.URL, requestPayload)
    .then(response => response.data);
}

